export const eLearningUrl = new URL('https://rise.articulate.com/share/ztmKzdL8saRK_pVFe69X8YzDo5keapgq#/');

export class BemAIIdentifiers {
  private static readonly identifier = 'Bem';

  static get clickTable() {
    return `${this.identifier}.ClickTable`;
  }

  static get changeCropField() {
    return `${this.identifier}.ChangeCropField`;
  }

  static get editPlantingDate() {
    return `${this.identifier}.EditPlantingdate`;
  }

  static get clickInfoMyArable() {
    return `${this.identifier}.ClickInfo_MyArable`;
  }

  static get clickInfoInsightsPage() {
    return `${this.identifier}.ClickInfo_Insightspage`;
  }

  static get changeTab() {
    return `${this.identifier}.ChangeTab`;
  }
}
